import { Row, Col } from 'antd';
import DocListPage from '../../components/DocComponents/DocListPage';
import { useAppContext } from '../../hooks/useAppContext';

export default function Dashboard() {
 
    const {docs} = useAppContext()

    return (
        <Row justify="center" align="middle" gutter={[15, 15]} style={{ height: '100%' }} >
            <Col xs={24}  style={{ height: '100%'}}>
                <DocListPage title='ბოლოს ატვირთული'docs={docs} pagination={true} />
            </Col>
        </Row>
    )
}